<radio [(ngModel)]="radio" value="Yes" name="radioBasicDemo">Yes</radio>
<radio [(ngModel)]="radio" value="No" name="radioBasicDemo">No</radio>